import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { CLEAR_LOADER, CLEAR_ERRORS, GET_REPORT_RESTAURANT,GET_EVENT_SUMMARY, SET_LOADER_SECONDARY,
  GET_OFFERS_ACTIVITY,GET_OFFER_SUMMARY,GET_ADMIN_OFFER_VENDOR,GET_ADMIN_SEATING_ACTIVITY,GET_ADMIN_SEATING_PENDING_ACTIVITY,
  GET_ADMIN_SEATING_SUMMARY,GET_ADMIN_SEATING_VENDOR,GET_ADMIN_ITEM_SUMMARY,GET_ADMIN_ITEM_VENDOR,GET_EVENT_VENDOR, GET_EXP_SUMMARY, GET_EXP_VENDOR,
} from "../../types";
import { setErrors, } from "../errorActions";

export const getAdminTaxReport = (currentdate, to, from) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  //   dispatch({ type: SET_LOADER });
  //   console.log(currentdate, to, from);
  try {
    let get_restaurant_reports = await axios.post(
      `${serverApi}/reports?currentdate=${currentdate}&to=${to}&from=${from}`
    );
    // console.log(get_restaurant_reports);
    if (get_restaurant_reports.status === 201) {
      dispatch({
        type: GET_REPORT_RESTAURANT,
        payload: get_restaurant_reports.data,
      });
      //   onSuccess();
      //   dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
    // onError();
  }
};

export const ExperienceSummaryReport =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    try {
      let get_event_summary = [];
      get_event_summary = await axios.get(
          `${serverApi}/expReport?summary=true&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_event_summary.status === 200) {
        dispatch({
          type: GET_EXP_SUMMARY,
          payload: get_event_summary.data,
        });
        dispatch({type: CLEAR_LOADER}); 
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const Exp_vendor_report =
  (token,vendor_id,type, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    try {
      let get_event_vendor = [];
      get_event_vendor = await axios.get(
          `${serverApi}/expRequestReports`,
          {
            headers: {
              Authorization: token,
            },
            params:{vendorId:vendor_id,type, ...dateQuery, reportType:'summary'}
          }
        );
      if (get_event_vendor.status === 200) {
        dispatch({
          type: GET_EXP_VENDOR,
          payload: get_event_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const Exp_Activity_report =
  (token,type, dateQuery, reportType) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    try {
      let get_event_vendor = [];
      get_event_vendor = await axios.get(
          `${serverApi}/expRequestReports`,
          {
            headers: {
              Authorization: token,
            },
            params:{type, ...dateQuery, reportType:reportType}
          }
        );
      if (get_event_vendor.status === 200) {
        dispatch({
          type: GET_EXP_VENDOR,
          payload: get_event_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const Exp_Refund_report =
  (token,type, dateQuery, reportType) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    try {
      let get_event_vendor = [];
      get_event_vendor = await axios.get(
          `${serverApi}/refundReports`,
          {
            headers: {
              Authorization: token,
            },
            params:{type, ...dateQuery, reportType:reportType}
          }
        );
      if (get_event_vendor.status === 200) {
        dispatch({
          type: GET_EXP_VENDOR,
          payload: get_event_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const Exp_Reset_report =
  (token,type, dateQuery, reportType, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    try {
      let get_event_vendor = [];
      get_event_vendor = await axios.get(
          `${serverApi}/resetSettlementReport`,
          {
            headers: {
              Authorization: token,
            },
            params:{type, ...dateQuery, reportType:reportType}
          }
        );
      if (get_event_vendor.status === 200) {
        dispatch({
          type: GET_EXP_VENDOR,
          payload: get_event_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        onSuccess()
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onSuccess()
    }
  };

export const Event_summary_report =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // sconsole.log(dateQuery);  
    try {
      let get_event_summary = [];
      get_event_summary = await axios.get(
          `${serverApi}/admin/events?summary=true&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_event_summary.status === 200) {
        dispatch({
          type: GET_EVENT_SUMMARY,
          payload: get_event_summary.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_event_summary",get_event_summary);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const Event_vendor_report =
  (token,vendor_id, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // sconsole.log(dateQuery);  
    try {
      let get_event_vendor = [];
      get_event_vendor = await axios.get(
          `${serverApi}/vendor/events?vendorId=${vendor_id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_event_vendor.status === 200) {
        dispatch({
          type: GET_EVENT_VENDOR,
          payload: get_event_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };


  export const Offers_Activity_Report =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_offers_activity = [];
      get_offers_activity = await axios.get(
          `${serverApi}/admin/offers-report?offerActivityReport=true&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/admin/offers-report?offerActivityReport=true`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_offers_activity.status === 200) {
        dispatch({
          type: GET_OFFERS_ACTIVITY,
          payload: get_offers_activity.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_offers_activity",get_offers_activity);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const offer_summary_report =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_offer_summary = [];
      get_offer_summary = await axios.get(
          `${serverApi}/admin/offers-report?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/admin/offers-report`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_offer_summary.status === 200) {
        dispatch({
          type: GET_OFFER_SUMMARY,
          payload: get_offer_summary.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_offer_summary",get_offer_summary);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const offer_vendor_report =
  (token,vendor_id, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_offer_vendor = [];
      get_offer_vendor = await axios.get(
          // `${serverApi}/admin/transactionalReport?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          `${serverApi}/admin/offers-report?vendorId=${vendor_id}`,
          // `${serverApi}/admin/offers-report?vendorId=5fd2542b4b194e7962acd664`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_offer_vendor.status === 200) {
        dispatch({
          type: GET_ADMIN_OFFER_VENDOR,
          payload: get_offer_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_offer_vendor",get_offer_vendor);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const seating_pending_activity_report =
  (token,dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_pending_seacting_activity = [];
      get_pending_seacting_activity = await axios.get(
          `${serverApi}/admin/diner-report?diner_status=PENDING&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/admin/diner-report?diner_status=PENDING`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_pending_seacting_activity.status === 200) {
        dispatch({
          type: GET_ADMIN_SEATING_PENDING_ACTIVITY,
          payload: get_pending_seacting_activity.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_pending_seacting_activity",get_pending_seacting_activity);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const seating_activity_report =
  (token,dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_seacting_activity = [];
      get_seacting_activity = await axios.get(
          `${serverApi}/admin/diner-report?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/admin/diner-report`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_seacting_activity.status === 200) {
        dispatch({
          type: GET_ADMIN_SEATING_ACTIVITY,
          payload: get_seacting_activity.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_seacting_activity",get_seacting_activity);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const seating_summary_report =
  (token,dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_seacting_summary = [];
      get_seacting_summary = await axios.get(
          `${serverApi}/Admin/diner-request?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/Admin/diner-request`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_seacting_summary.status === 200) {
        dispatch({
          type: GET_ADMIN_SEATING_SUMMARY,
          payload: get_seacting_summary.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_seacting_summary",get_seacting_summary);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const seating_vendor_report =
  (token,vendor_id,dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_seating_vendor = [];
      get_seating_vendor = await axios.get(
          `${serverApi}/admin/diner-report?vendor_id=${vendor_id}&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/admin/diner-report?vendor_id=${vendor_id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_seating_vendor.status === 200) {
        dispatch({
          type: GET_ADMIN_SEATING_VENDOR,
          payload: get_seating_vendor.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_seating_vendor",get_seating_vendor);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  export const item_summary_report =
  (token,dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({type: SET_LOADER_SECONDARY});  
    // console.log(dateQuery);  
    try {
      let get_item_summary = [];
      get_item_summary = await axios.get(
          `${serverApi}/vendor/item-report?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
          // `${serverApi}/vendor/item-report`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      if (get_item_summary.status === 200) {
        dispatch({
          type: GET_ADMIN_ITEM_SUMMARY,
          payload: get_item_summary.data,
        });
        dispatch({type: CLEAR_LOADER}); 
        console.log("get_item_summary",get_item_summary);       
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
     
    }
  };

  // export const item_vendor_report =
  // (token,dateQuery) => async (dispatch) => {
  //   dispatch({ type: CLEAR_ERRORS });
  //   dispatch({type: SET_LOADER_SECONDARY});  
  //   // console.log(dateQuery);  
  //   try {
  //     let get_item_vendor = [];
  //     get_item_vendor = await axios.get(
  //         // `${serverApi}/vendor/item-report?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
  //         `${serverApi}/vendor/item-report/${vendorId}`,
  //         {
  //           headers: {
  //             Authorization: token,
  //           },
  //         }
  //       );
  //     if (get_item_vendor.status === 200) {
  //       dispatch({
  //         type: GET_ADMIN_ITEM_VENDOR,
  //         payload: get_item_vendor.data,
  //       });
  //       dispatch({type: CLEAR_LOADER}); 
  //       console.log("get_item_vendor",get_item_vendor);       
  //     }
  //   } catch (err) {
  //     dispatch({ type: CLEAR_LOADER });
  //     dispatch(setErrors(err));
     
  //   }
  // };
